// extracted by mini-css-extract-plugin
module.exports = {"big":"ChatLabel_big__SoFcu"};